<template>
    <div>
        <div class="row">
            <!--İsim-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
                    <InputText maxlength="80" placeholder="Adınız" v-model="$store.state.clientName" @keyup="this.$store.state.clientName=this.$store.state.clientName.toLocaleUpperCase('tr-TR');" />
                </div>
            </div>
            <!--soyad-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-users"></i>
                    </span>
                    <InputText maxlength="80" placeholder="Soyadınız" v-model="$store.state.clientSurname" @keyup="this.$store.state.clientSurname=this.$store.state.clientSurname.toLocaleUpperCase('tr-TR');" />
                </div>
            </div>
            <!--mail-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-info-circle"></i>
                    </span>
                    <InputText maxlength="346" placeholder="Mail adresiniz" v-model.trim="$store.state.clientMailAddress" @keyup="$store.state.clientMailAddress=$store.state.clientMailAddress.trim()" />
                </div>
            </div>
            <!--Cinsiyet-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-info-circle"></i>
                    </span>
                    <CascadeSelect v-model="$store.state.gender" :options="genders" optionLabel="cinsiyet" optionGroupLabel="Cinsiyet"
                                   :optionGroupChildren="['states', 'cities']" style="minWidth: 14rem" placeholder="Cinsiyetinizi seçiniz." />
                </div>
            </div>
            <!--telefon no-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-phone"></i>
                    </span>
                    <label for="Phone"><strong></strong></label>
                    <InputMask mask="(999) 999-9999" v-model="$store.state.clientPhone" placeholder="(5xx) xxx-xxxx" />
                </div>
            </div>

            <!--Ülke seçimi.-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-globe"></i>
                    </span>
                    <Dropdown class="w100" v-model="$store.state.clientCountry" :options="vuexGetters_countries" optionLabel="name" :filter="true" placeholder="Select a Country">
                        <template #value="slotProps">
                            {{slotProps.value.name}}
                        </template>
                        <template #option="slotProps">
                            <div>{{slotProps.option.name}}</div>
                        </template>
                    </Dropdown>
                </div>
            </div>


            <!--id input-->
            <div v-if="$store.state.clientCountry.code == 'TR'" class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-id-card"></i>
                    </span>
                    <div style="margin-top: 20px;"></div>
                    <InputMask class="w100" mask="99999999999" v-model="$store.state.clientID" mode="decimal" :useGrouping="false" placeholder="Türkiye cumhuriyeti kimlik numaranızı giriniz." />
                </div>
            </div>
            <div v-else class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-id-card"></i>
                    </span>
                    <div style="margin-top: 20px;"></div>
                    <InputMask class="w100" mask="**-999-9999" v-model="$store.state.clientPassportNo" mode="decimal" :useGrouping="false" placeholder="Pasaport numaranızı giriniz." />
                </div>
            </div>

            <!--doğumgünü-->
            <div class="form-group col-sm-12 col-md-6 ">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-calendar"></i>
                    </span>
                    <label for="datetemplate"></label>

                    <InputMask placeholder="Doğum Tarihini Gün.Ay.Yıl(30.12.1995) şeklinde giriniz."
                               id="datetemplate"
                               v-model="$store.state.clientBirthDay"
                               mask="99.99.9999" />


                    <Calendar placeholder="Doğum Tarihini Gün.Ay.Yıl(30.12.1995) şeklinde giriniz."
                              v-if="1==2"
                              id="datetemplate"
                              v-model="$store.state.clientBirthDay"
                              dateFormat="dd.mm.yy"
                              :monthNavigator="true"
                              :yearNavigator="true"
                              :showIcon="false" />
                </div>
            </div>


            <!--passport number input-->
            <!--notes-->
            <div class="p-col-12 p-md-6 p-lg-3" v-if="1==2">
                <h5><strong>Not etmek istediklerinizi yazınız.</strong></h5>
                <Textarea v-model="$store.state.clientNote" :autoResize="true" rows="3" cols="15" placeholder="Randevu almadan önce hastanemizle paylaşmak isteyebileceğiniz bilgiler." />
            </div>
        </div>



        <!--file upload-->
        <h5 v-if="1==2">Hastanemize gelmeden önce yüklemek istediğiniz dosya ve raporlar</h5>
        <FileUpload name="demo[]" url="./upload.php" @upload="onUpload" :multiple="true" accept="image/*" :maxFileSize="1000000" v-if="1==2">
            <template #empty>
                <p>Gerekli dosyaları buraya sürükleyerek yükleyebilirsiniz..</p>
            </template>
        </FileUpload>





        <!--Marketing and agreement-->
        <div class="row">
            <div class="col-sm-12"></div>

            <div class="p-field-checkbox">
                <Checkbox id="kvkk-text" v-model="isCheckedKvkk" :binary="true" />
                <span style="margin-left:10px;"> <a href="#" for="kvkk-text" @click="display=true">Kişisel Verilerin Korunması Kanunu'nu</a> Okudum ve Onaylıyorum.</span>
            </div>
            <br />
            <div class="p-field-checkbox" style="margin-top:10px;">
                <Checkbox id="binary" v-model="$store.state.isAcceptedMarketing" :binary="true" />
                <span style="margin-left:10px;" for="binary">Özel Dr.Cem Yılmaz Meme Cerrahisi Hastanesi tarafından her türlü bilgilendirme, anket, tanıtım, açılış, davet ve etkinlik vb. hatırlatmaları ile diğer sair iletişim çalışmaları kapsamında tarafıma Ticari Elektronik İleti(arama,sms,mail vb.) gönderilmesini kabul ediyorum.</span>
            </div>
        </div>

        <Dialog v-model:visible="display" header="Aydınlatma Metni" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}">
            <KVKK />
        </Dialog>

        <Button class="p-button-outlined w100" style="margin-top:1%;" label="Randevu Al" @click="dataCheck()"></Button>
        <ConfirmDialog></ConfirmDialog>

    </div>
</template>


<script>

    import { mapGetters, mapActions, mapMutations } from "vuex"
    import { useToast } from 'primevue/usetoast'
    import KVKK from "./KVKK.vue";


    export default {
        components: {
            KVKK
        },
        setup() {
            const toast = useToast();
        },
        data() {
            return {
                placeholderForId: 'T.C. kimlik numaranızı ya da pasaport numarınızı giriniz.',
                genders: [
                    { cinsiyet: 'Erkek', code: 'M' },
                    { cinsiyet: 'Kadın', code: 'F' }
                ],
                display: false,
                isCheckedKvkk: false
            }
        },
        computed: {
            ...mapGetters(["vuexGetters_countries", "vuexGetters_clientCountry", "vuexGetters_isAcceptedAgreement", "vuexGetters_isFilled", "vuexGetters_clientID", "vuexGetters_clientPassportNo", "vuexGetters_clientMailAddress"]),
        },
        created() {
        },
        methods: {
            ...mapActions(["vuexAction_DataChecker",
                "vuexAction_setFalseAgreementData",
                "vuexAction_isAllFilled",
                "vuexAction_InitData",
                "vuexAction_setTrueAgreementData"
            ]),
            ...mapMutations(["vuexMutation_manipulatePassportNo"]),
            checkTcNum(value) {
                value = value.toString();
                var isEleven = /^[0-9]{11}$/.test(value);
                var totalX = 0;
                for (var i = 0; i < 10; i++) {
                    totalX += Number(value.substr(i, 1));
                }
                var isRuleX = totalX % 10 == value.substr(10, 1);
                var totalY1 = 0;
                var totalY2 = 0;
                for (var x = 0; x < 10; x += 2) {
                    totalY1 += Number(value.substr(x, 1));
                }
                for (var y = 1; y < 10; y += 2) {
                    totalY2 += Number(value.substr(y, 1));
                }
                var isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9, 0);
                return isEleven && isRuleX && isRuleY;
            },
            checkPassportNum(passport) {
                var regsaid = /[a-zA-Z0-9]{2}[0-9]{7}/;
                return regsaid.test(passport);
            },
            showLegalText() {
                this.display = true
            },
            rejectAgreement() {
                this.display = false
                this.vuexAction_setFalseAgreementData
            },
            acceptAgreement() {
                this.display = false
                this.vuexAction_setTrueAgreementData//makes agreement true
            },
            confirm1() {
                this.$confirm.require({
                    message: 'Girdiğiniz bilgilerin doğru olduğundan emin misiniz?',
                    header: 'Randevu İşlemi',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.vuexAction_InitData();
                    },
                    reject: () => {
                        this.$toast.add({ severity: 'warn', summary: 'Uyarı', detail: 'Lütfen bilgilerinizi tekrardan, doğru bir şekilde giriniz.', life: 3000 });
                    }
                });
            },
            ValidateEmail(mail) {
                if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
                    return (true)
                } //uses regex to validate is citizenID legit or not
                return (false)
            },
            formatDateTime(datetime) {
                return new Date(datetime).toLocaleDateString();
            },
            dataCheck() {
                this.vuexMutation_manipulatePassportNo();

                this.vuexAction_isAllFilled().then(res => {
                    if (res) {
                        if (this.checkTcNum(this.vuexGetters_clientID) || this.checkPassportNum(this.vuexGetters_clientPassportNo)) {
                            if (this.ValidateEmail(this.vuexGetters_clientMailAddress)) {
                                if (!this.isCheckedKvkk) {
                                    this.$toast.add({
                                        severity: 'error', summary: 'İşlem Başarısız', detail: "Kişisel Verilerin Korunması Kanunu'nu okudum ve onaylıyorum seçeneğini işaretleyiniz.", life: 3000
                                    });
                                    return;
                                }
                                this.confirm1();
                            }
                            else {
                                this.$toast.add({ severity: 'error', summary: 'İşlem Başarısız', detail: 'Mail adresinizi doğru girdiğinizden emin olun.', life: 3000 })
                            }
                        }
                        else {
                            this.$toast.add({ severity: 'error', summary: 'İşlem Başarısız', detail: 'Lütfen Vatandaşlık Numaranızı doğru girdiğinize emin olun.', life: 3000 })
                        }
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'İşlem Başarısız', detail: 'Lütfen bütün alanları eksiksiz doldurun.', life: 3000 })
                    }
                });
            },
        }
    }

</script>

<style>
    .randevubutton {
        margin-top: 25px;
        text-align: center !important;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    .row {
        display: -webkit-box;
        flex-wrap: wrap;
    }

    #legal-text {
        color: #005bff;
    }

        #legal-text:link {
            color: green;
            background-color: transparent;
            text-decoration: none;
        }

        #legal-text:visited {
            color: pink;
            background-color: transparent;
            text-decoration: none;
        }

        #legal-text:hover {
            color: blue;
            background-color: transparent;
            text-decoration: underline;
        }

        #legal-text:active {
            color: black;
            background-color: transparent;
            text-decoration: underline;
        }

    .p-disabled, .p-component:disabled {
        opacity: 1.0 !important;
    }
</style>
